import React, { PropTypes } from 'react';

import { organiserFullPropTypeShape } from '../../proptypes';

import Container from '../Container';
import EventListCounter from '../EventListCounter/EventListCounterContainer.react';
import EventList from '../EventList/EventListContainer.react';
import PageHeader from '../PageHeader';

import { header, heading } from './styles.module.css';

/**
 * Organiser detail presentational component.
 */
const OrganiserDetail = ({ description, images, searchQuery, title }) => (
  <div>
    <PageHeader
      title={title}
      description={description}
      logo={images && images.logo && images.logo.thumbnail}
      className={header}
    />
    <Container>
      <h2 className={heading}><EventListCounter query={searchQuery} /></h2>
      <EventList query={searchQuery} source="organiser_page" />
    </Container>
  </div>
);

OrganiserDetail.propTypes = {
  /**
   * HTML string description of organiser.
   */
  description: organiserFullPropTypeShape.description,
  /**
   * Object containing image data objects.
   */
  images: organiserFullPropTypeShape.images,
  /**
   * Query object for 'search' query.
   */
  searchQuery: PropTypes.shape(),
  /*
   * String title of the organiser.
   */
  title: organiserFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

OrganiserDetail.defaultProps = {
  description: undefined,
  images: undefined,
  searchQuery: undefined,
};

export default OrganiserDetail;



// WEBPACK FOOTER //
// ./app/src/components/OrganiserDetail/index.jsx